import { mainnet } from "wagmi";
import { getBlockExplorerForNetwork, getChainFromId } from "./chainUtils";
import { TransactionDetail } from "types/history";

export const openTransactionInBlockExplorer = (
  chainId: TransactionDetail["chain_id"],
  txHash: TransactionDetail["txHash"]
) => {
  const chainFromId = getChainFromId(chainId) ?? mainnet;
  const explorerUrl = `${getBlockExplorerForNetwork(chainFromId)}tx/${txHash}`;
  window.open(explorerUrl, "_blank");
};
